'use client';

import { useState } from 'react';

/**
 * Foto que falha ao carregar (404 no armazenamento, URL vencida) cai no fallback do componente —
 * sem isto o navegador escreve o `alt` (o nome) por cima do círculo. Mesma regra do `AgentAvatar`
 * da #570: guarda a URL que FALHOU, então uma URL nova tenta a foto de novo sem efeito para
 * "resetar". #579.
 */
export function useFotoQueFalha(url: string | null | undefined) {
  const [urlQueFalhou, setUrlQueFalhou] = useState<string | null>(null);
  return {
    mostraFoto: !!url && url !== urlQueFalhou,
    aoFalhar: () => setUrlQueFalhou(url ?? null),
  };
}
